import moment from 'moment';
// eslint-disable-next-line import/no-unresolved,import/extensions
import QrCodeScanner from '../../../components/QrCodeScanner';
import InstallationTable from '../installationTable/InstallationTable.vue';
import Photo from '../../../components/photo/Photo.vue';


const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  props: ['action_id', 'id'],
  components: { InstallationTable, QrCodeScanner, Photo },
  data() {
    return {
      sendButtonLoading: false,
      date: new Date().toISOString().substr(0, 10),
      showPicker: false,
      installationID: this.$props.id,
      actionID: this.$props.action_id,
      showHistory: false,
      product: null,
      setProduct: false,
      productPrice: '',
      productFound: null,
      barcodeFound: null,
      eanCode: '',
      uCode: '',
      sum: 0,
      checkedPers: false,
      showCard: false,
      checkPhoto: {
        base64: '',
        name: '',
      },
      sendSmsCode: false,
      smsCode: null,
      customerChecked: false,
      valid: false,
      installationDraft: null,
      newInstallation: {
        action_id: +this.$props.action_id,
        positions: [],
        documents: [],
        photo_local: [],
        document_local: [],
      },
      searchProduct: '',
      productsList: [],
      barcodeList: [],
      isLoading: false,
      showUCode: false,
      scanQrCode: {
        openModal: false,
      },
      showScanCamera: false,
      type: 'individual',
      ttn: '',
      ticketHeaders: [
        { text: 'Продукт', value: 'name' },
        { text: 'Цена', value: 'price' },
        { text: 'Кол-во', value: 'quantity' },
        { text: 'Сумма', value: 'sum' },
      ],
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => (!v.length || pattern.test(v)) || 'Поле E-mail заполнено с ошибками',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
      },
    };
  },
  computed: {
    // Возможность сохранить черновик
    draftEnabled() {
      return !!(this.newInstallation.photo_local.length
        || this.newInstallation.document_local.length);
    },
    user() {
      return this.$store.state.user;
    },
    useCustomerForm() {
      if (this.$store.state.settings.testFeatures.includes('customer_form')) {
        if (this.$store.state.settings.testProfileIds.includes(this.$store.state.user.profile_id)) {
          return true;
        }
        return false;
      }
      return true;
    },
    action() {
      return this.$store.state.installations.action;
    },
    isLegal() {
      return this.type === 'legal_entity';
    },
    isIndividual() {
      return this.type === 'individual';
    },
    customerCode() {
      if (this.installation && this.installation.customer_code) {
        return this.installation.customer_code;
      }
      return this.$store.state.installations.customerCode
        ? this.$store.state.installations.customerCode
        : null;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    isEnabled() {
      return !!this.name && !!this.email && !!this.phone && !!this.message;
    },
    installation() {
      return this.$store.state.installations.installation;
    },
    installationsRules() {
      return this.$store.state.installations.installationsRules;
    },
    products() {
      const { action } = this.$store.state.installations;
      if (action !== null) {
        return action.products;
      }
      return [];
    },
    validation() {
      // return !!(this.valid && this.newInstallation.documents.length);
      return !!(this.valid);
    },
  },
  methods: {
    /**
     * Получение чека
     * @param qrcode
     */
    getTicket(qrcode) {
      const app = this;
      qrcode = qrcode.toLowerCase();
      if (app.newInstallation.tickets.find(t => t.qrcode.toLowerCase() === qrcode)) {
        app.$store.dispatch('ShowInfo', 'Чек уже отсканирован');
        return;
      }
      app.isLoading = true;
      app.$store.getters.axl.post('fns/api/tickets/info', {
        qrcode,
        profile_id: this.user.profile_id,
      })
        .then((response) => {
          if (response.data.ticket) {
            app.newInstallation.tickets.push(response.data.ticket);
            app.$store.dispatch('ShowInfo', 'Чек распознан');
          } else {
            app.$store.dispatch('ShowInfo', 'Код не найден');
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        }).finally(() => {
          app.isLoading = false;
          app.scanQrCode.openModal = false;
        });
    },

    /**
     * Форматирование даты
     * @param date дата в формате YYYY-MM-DD
     */
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },

    dateToFormat(date, format = 'DD.MM.YYYY') {
      if (!date) return null;
      return moment(date).format(format);
    },

    formatPrice(val) {
      const numberFormat = Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' });
      return numberFormat.format(val);
    },

    /** Получить timestamp. */
    setUniqueId() {
      return (new Date()).getTime();
    },
    /**
     * Получение уникальных кодов товара
     * @param product - объект товара
     * @returns {{code: null | string, id: null | number}}
     */
    GetBarcode(product) {
      if (product.barcodes && !!this.uCode) {
        const barcode = product.barcodes.find(item => item.barcode_code === this.uCode);
        if (barcode) {
          return { id: barcode.barcode_id, code: barcode.barcode_code };
        }
      }
      if (product.barcode_id) {
        return { id: product.barcode_id, code: product.barcode_code };
      }
      if (product.barcode && product.barcode.id) {
        return { id: product.barcode.id, code: product.barcode.code };
      }
      return { id: null, code: null };
    },
    /** Добавляем продукт в список */
    AddProduct() {
      this.newInstallation.positions.push({
        listID: this.setUniqueId().toString(),
        article: this.product.article,
        photo_url: this.product.photo_url,
        product_id: this.product.id,
        name: this.product.name,
        quantity: 1,
        cost: this.productPrice,
        barcode_id: this.GetBarcode(this.product).id,
        barcode_code: this.GetBarcode(this.product).code,
        bonuses: this.product.bonuses,
      });
      this.product = null;
      this.productPrice = '';
      this.barcodeFound = null;
      this.productFound = null;
      this.eanCode = '';
      this.uCode = '';
      this.CalculateSum();
    },
    /**
     * Удалить продукт из списка.
     * @param listID Идентификатор элемента в списке продуктов.
     * @constructor
     */
    DeleteProduct(listID) {
      this.newInstallation.positions = this.newInstallation.positions.filter(
        item => item.listID !== listID,
      );
      this.CalculateSum();
    },
    ChangePosition(listID) {
      const position = this.newInstallation.positions.find(item => item.listID === listID);
      this.DeleteProduct(listID);
      this.product = this.productsList.find(item => item.id === position.product_id);
      this.productPrice = position.cost;
      this.uCode = position.barcode_code || '';
      if (position.barcode_code) {
        this.barcodeFound = true;
        this.productFound = true;
      }
    },
    GetSkuName(search, type) {
      const app = this;

      if (search) {
        if (type === 'barcode' && this.barcodeList) {
          const searchBarcode = this.barcodeList.find(item => item.barcode_code === search);
          if (searchBarcode) {
            const product = this.productsList.find(item => item.id === searchBarcode.product_id);
            app.barcodeFound = searchBarcode;
            app.productFound = product;
            app.product = product;
            app.setProduct = false;
            app.$store.dispatch('ShowInfo', 'Товар найден');
            return;
          }
        }

        const payload = { type, search, action_id: this.$props.action_id };
        app.$store.dispatch('installations/GetSkuName', payload)
          .then((data) => {
            app.barcodeFound = data.barcode || null;
            app.productFound = data.product || null;
            if (data.product) {
              app.setProduct = true;
              const product = { ...data.product };
              if (data.barcode) {
                const barcode = {
                  barcode_id: data.barcode.id,
                  barcode_code: data.barcode.code,
                  product_id: data.product.id,
                };
                this.barcodeList.push(barcode);
                product.barcodes = product.barcodes ? [...product.barcodes, barcode] : [barcode];
              }
              app.product = product;
              this.productsList = [
                ...this.productsList.filter(item => item.id !== product.id), product,
              ];
              app.$store.dispatch('ShowInfo', 'Товар найден');
              app.eanCode = '';
              // app.uCode = ''; // Надо чистить только при добавлении товара
              app.setProduct = false;
            }
          });
      }
    },
    /**
     * Подсчет суммы баллов за добавленные продукты.
     */
    CalculateSum() {
      this.sum = 0;
      let sum = 0;
      if (this.newInstallation.positions.length) {
        for (let i = 0; i < this.newInstallation.positions.length; i += 1) {
          sum += (
            this.newInstallation.positions[i].bonuses_formula
            * this.newInstallation.positions[i].quantity
          );
        }
      }
      this.sum = sum;
    },
    /**
     * Проверка типа документа.
     * @param photo {Object} объект документа.
     * @returns {*|boolean}
     */
    CheckPDF(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/pdf;') !== -1);
      }
      if (photo.url) {
        return (photo.url.indexOf('.pdf') !== -1);
      }
      return false;
    },
    /**
     * Получение пути до файла.
     * @param photo объект документа.
     * @returns {*}
     */
    GetFilePath(photo) {
      if (photo.base64 || photo.url) {
        return photo.url ? photo.url : photo.base64;
      }
      return '';
    },
    /**
     * Добавление документа к продаже.
     * @param e эвент
     */
    OnFilePicked(e) {
      const doc = this.checkPhoto;
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        const [file] = files;
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        doc.name = file.name;

        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          doc.filename = null;
          doc.id = null;
          doc.base64 = fr.result;
          app.newInstallation.documents
            .push({ name: doc.name, base64: doc.base64, uid: app.setUniqueId() });
          this.checkPhoto = { filename: '', base64: '', name: '', url: '', id: null };
          app.$forceUpdate();
        });
      } else {
        this.checkPhoto = { filename: '', base64: '', name: '', url: '', id: null };
      }
    },
    /**
     * Удаление фотографии.
     * @param photo объект прикрепленного файла.
     */
    deleteFile(photo) {
      this.newInstallation.documents = this.newInstallation.documents.filter(
        item => item.uid !== photo.uid,
      );
      this.checkPhoto = {
        base64: '',
        name: '',
        filename: '',
        url: '',
      };
    },
    /** Отправка проверочного sms кода */
    SendSms() {
      if (!this.newInstallation.customer_phone && !this.newInstallation.customer_name) {
        return;
      }
      const app = this;
      app.$store.getters.axl.post('profiles/api/customer-code/send-sms', {
        phone: this.newInstallation.customer_phone,
        name: this.newInstallation.customer_name,
        code_id: this.customerCode.id,
        action_id: this.newInstallation.action_id,
      })
        .then(() => {
          app.sendSmsCode = true;
          app.$store.dispatch('ShowInfo', 'Код отправлен вам на телефон');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    /** Отправка кода */
    SendCode() {
      if (!this.smsCode) {
        return;
      }
      const app = this;
      app.$store.getters.axl.post('profiles/api/customer-code/check-sms', {
        phone: this.newInstallation.customer_phone,
        sms_code: this.smsCode,
        code_id: this.customerCode.id,
      })
        .then((response) => {
          if (response && response.data && response.data.customer) {
            app.customerChecked = true;
            app.newInstallation.customer_id = response.data.customer.id;
            app.$store.dispatch('ShowInfo', 'Проверка успешно пройдена');
            app.checkedPers = true;
          } else {
            app.$store.dispatch('ShowError', 'Данные не получены. попробуйте ещё раз!');
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    GetCustomerCode() {
      this.$store.dispatch('installations/GetCustomerCode', {
        profile_id: this.user.profile_id,
        action_id: +this.actionID,
      })
        .then((data) => {
          if (data && data.customer_code) {
            this.newInstallation.customer_code_id = data.customer_code.id;
          }
        });
    },
    preloadInstallation(data) {
      if (data) {
        this.installationDraft = { ...data };
        this.type = data.type;
        this.ttn = data.ttn;
        const positions = data.positions.map((p, idx) => ({
          ...p,
          name: p.product.name,
          barcode_id: this.GetBarcode(p).id,
          barcode_code: this.GetBarcode(p).code,
          listID: `${this.setUniqueId().toString()}${p.product.id}${idx}`,
        }));

        // Получить наименование документа из урлы
        const getDocNameFromUrl = (doc) => {
          const index = doc.lastIndexOf('/');
          return doc.slice(index + 1, doc.length);
        };
        const documents = data.documents ? data.documents.map((i, idx) => ({ ...i, uid: `${this.setUniqueId()}${idx}` })) ?? [] : [];
        this.newInstallation = {
          action_id: data.action_id,
          sold_on_local: data.sold_on_local,
          positions,
          documents,
          customer_code_id: (data.customer_code) ? data.customer_code.id : '',
          customer_id: (data.customer_code && data.customer)
            ? data.customer.profile_id : '',
          customer_phone: (data.customer_phone) ? data.customer_phone : '',
          customer_name: (data.customer_name) ? data.customer_name : '',
          document_local:
            data.document ? [{ url: data.document, name: getDocNameFromUrl(data.document) }] : [],
          photo_local: data.photo ? [{ url: data.photo, name: getDocNameFromUrl(data.photo) }] : [],
        };
      }
    },
    /** Получить список товаров */
    getProducts(field, val = '') {
      const app = this;
      app.isLoading = true;
      app.$store.getters.ax.post('actions/api/action/get-sku-names', {
        search: val,
        type: 'name',
        action_id: +app.$props.action_id,
      })
        .then((response) => {
          if (response.data.products !== null && Array.isArray(response.data.products)
            && response.data.products.length) {
            app.$data[field] = response.data.products;
          }
          app.isLoading = false;
        });
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit(draft = false) {
      const app = this;
      if (!draft && this.product) {
        app.$store.dispatch('ShowInfo', 'Товар не добавлен');
        return;
      }
      this.sendButtonLoading = true;
      const url = this.installationID !== 'null' ? 'installations/api/installation/update' : 'installations/api/installation/create';
      if (app.valid) {
        const payload = {
          ...app.newInstallation,
          is_draft: draft,
          profile_id: app.user.profile_id,
          type: app.type,
          ttn: app.ttn,
        };

        if (this.installationID !== 'null') {
          payload.installation_id = +this.installationID;
        }

        app.$store.getters.axl.post(url, payload)
          .then(() => {
            app.$router.push('/installations/');
            app.$store.dispatch('ShowInfo', 'Монтаж отправлен на проверку');
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          }).finally(() => {
            this.sendButtonLoading = false;
          });
      }
    },
    stopQrScan(error) {
      this.$store.dispatch('ShowErrorMessage', error);
      this.scanQrCode.openModal = false;
    },
  },
  watch: {
    /** Вотчер для форматирования установленной даты */
    date(val) {
      this.newInstallation.sold_on_local = val && this.formatDate(val);
    },
  },
  created() {
    if (this.actionID !== 'null') {
      this.$store.dispatch('installations/GetAction', {
        action_id: +this.actionID,
      });
    }
    this.getProducts('productsList');
  },
  mounted() {
    const app = this;
    if (app.installationID !== 'null') {
      app.$store.dispatch('installations/GetInstallation', {
        profile_id: app.user.profile_id,
        installation_id: +app.installationID,
      })
        .then((data) => {
          app.preloadInstallation(data.installation);
        });
    }
  },
};
